import FormWrapper from '@/components/form/form-wrapper/form-wrapper';
import { FieldType, SignInForm } from '@/components/sign-in-form/sign-in-form';
import VerificationForm from '@/components/verification-form/verification-form';
import { useAuth } from '@/hooks/use-auth/use-auth';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { safeRedirectPath } from '@/services/session/sign-in-redirect';
import { Flex } from 'antd';
import styles from './sign-in.module.scss';
import { HttpStatusCode } from 'axios';
import arrowImage from '@/assets/images/arrow.svg';

export function SignIn() {
  const { authUser, isAuthorizing, authError } = useAuth();
  const [userEmail, setUserEmail] = useState('');

  const navigate = useNavigate();
  const { state } = useLocation();

  // Router state covers a PrivateRoute redirect. The ?from= query covers the expiry path,
  // which is a document navigation and so carries no router state. The query value comes off
  // a link, so it is filtered down to a same-origin path.
  const [searchParams] = useSearchParams();
  const from =
    safeRedirectPath(state?.from) ?? safeRedirectPath(searchParams.get('from')) ?? '/';

  const onFinish = async ({ email, password }: FieldType) => {
    const response = await authUser({ email, password });

    if (response?.user.mfa_required) {
      setUserEmail(email);
      navigate('/sign-in', {
        state: {
          verification: true,
          mfaToken: response.user.mfa_token,
          availableMethods: response.user.available_methods,
          userEmail: email,
          from,
        },
      });
    } else {
      navigate(from, { replace: true });
    }
  };

  return (
    <Flex vertical align="center">
      <FormWrapper>
        {!state?.verification ? (
          <SignInForm
            onSubmit={onFinish}
            errors={
              authError?.response?.status === HttpStatusCode.Unauthorized
                ? ''
                : authError?.response?.data.errors
            }
            isLoading={isAuthorizing}
          />
        ) : (
          <VerificationForm
            userEmail={state?.userEmail || userEmail}
            mfaToken={state?.mfaToken}
            availableMethods={state?.availableMethods}
          />
        )}
      </FormWrapper>
      <img className={styles.arrow} src={arrowImage} />
    </Flex>
  );
}
